import type { AnalyticsPage } from "src/components/adobeAnalytics/trackPageView/trackPageView"

// VehicleDetailsContainer (and its buildsheet/vehicle-history tab children) are mounted at 3 base
// routes: routes.inventoryList.vehicleDetails, routes.deliveredVehiclesList.vehicleDetails (legacy,
// permission-gated), and routes.fulfillmentDeliveredVehiclesList.usedVehicles.vehicleDetails. Since
// they share the same components, the tracked AnalyticsPage id must be derived from the current
// pathname so analytics can distinguish which entry point a dealer is viewing.
type VehicleDetailsAnalyticsBase =
	| "inventory_vehicle_details"
	| "delivered_vehicle_details"
	| "used_delivered_vehicle_details"

// Derived from the existing "inventory_vehicle_details_*" AnalyticsPage variants (currently "buildsheet" |
// "vehicle_history") instead of hand-duplicated, so adding/renaming a tab variant in
// trackPageView.ts is caught here as a type error instead of silently drifting.
type ExtractVehicleDetailsSuffix<Page> = Page extends `inventory_vehicle_details_${infer Suffix}` ? Suffix : never
export type VehicleDetailsAnalyticsSuffix = ExtractVehicleDetailsSuffix<AnalyticsPage>

export const getVehicleDetailsAnalyticsPage = (
	pathname: string,
	tab: "overview" | VehicleDetailsAnalyticsSuffix,
): AnalyticsPage => {
	const base: VehicleDetailsAnalyticsBase = pathname.includes("/delivered-vehicles/used/")
		? "used_delivered_vehicle_details"
		: pathname.includes("/delivered-vehicles/")
			? "delivered_vehicle_details"
			: "inventory_vehicle_details"

	return tab === "overview" ? base : `${base}_${tab}`
}
